import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { SaveOptions } from 'breeze-client';
import { bridge } from '../bridge';
import * as _entityManagerProvider from '../entitymanagerprovider';
import * as _repository from '../repository';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class UnitOfWorkService {
    provider = _entityManagerProvider.create();
    bridge: bridge;
    initialized: boolean = false;

    constructor(private http: HttpClient, private toastr: ToastrService) { }

    init() {
        if (this.initialized) {
            return;
        }

        this.bridge = new bridge(this.http, this.provider);
        this.provider.manager().hasChangesChanged.subscribe((evt) => {
            this.hasChanges.next(evt.hasChanges);
        });

        this.initialized = true;
    }

    hasChanges = new BehaviorSubject(false);

    commit() {
        var saveOptions = new SaveOptions({ resourceName: 'savechanges' });

        return this.provider.manager().saveChanges(null, saveOptions)
            .then(function (saveResult) {
                //_app.trigger('saved', saveResult.entities);
            });
    }

    rollback() {
        this.provider.manager().rejectChanges();
    }

    //create repositorys for entity types you need access to
    employees = _repository.create<model.employee>(this.provider, 'Employee', 'employees', this.toastr);
    workspaceRights = _repository.create<model.workspaceRight>(this.provider, 'WorkspaceRight', 'workspaceRights', this.toastr);

    authIsAdmin() {
        return this.bridge.authIsAdmin();
    }

    getWorkspaceRights() {
        return this.bridge.getWorkspaceRights();
    }

    documentView(library: string, id: number) {
        return this.bridge.documentView(library, id);
    }

    browse(library: string, workspace: number, id: number) {
        return this.bridge.browse(library, workspace, id);
    }

    getAdminWorkspaceRights() {
        return this.bridge.getAdminWorkspaceRights();
    }

    searchWorkspace(library: string, workspace: number, query: string) {
        return this.bridge.searchWorkspace(library, workspace, query);
    }
}
